import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Spinner } from 'reactstrap';
import useTheme from '../../hooks/useTheme';

export default function DialogBox({ isOpen, title, message, buttons, toggle }) {
    const theme = useTheme();

    return (
        <Modal isOpen={isOpen} toggle={toggle} centered backdrop="static">
            {title && <ModalHeader toggle={toggle}>{title}</ModalHeader>}
            <ModalBody className={theme === 'dark-mode' ? "text-light" : "text-dark"}>{message}</ModalBody>
            <ModalFooter>
                {buttons.map((btn, index) => {
                    return (
                        <Button disabled={btn.disabled || btn.loading} key={index} color={btn.color || 'secondary'} onClick={btn.onClick}>
                            {btn.loading && <Spinner size="sm" color="light" className="me-1" />}
                            {!btn.loading && btn.icon && <i className={`me-2 ${btn.icon}`}></i>}
                            {btn.label}
                        </Button>
                    )
                })}
            </ModalFooter>
        </Modal>
    )
}